import PropTypes from 'prop-types';
import React from 'react';
import {
    Button,
    DataTable,
    TableContainer,
    TableToolbar,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableHeader,
    TableCell,
    TableToolbarContent,
    Tile,
  } from 'carbon-components-react';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Add16 from '@carbon/icons-react/lib/add/16';
import { NoRecordsPlaceholder } from '../../../../../helpers/jsonschemaform/DataTableExtention';
import moment from 'moment';

const Timeline = ({timelineHeader, dataRows, timelineTblTitle, editingDisabled, validationTimelines,  handleNewElementModal, handleDeleteElementModal}) => {

    return (
        <Tile light>
          <DataTable
            useZebraStyles
            rows={dataRows}
            headers={timelineHeader}
            render={({ rows, getHeaderProps }) => (
              <TableContainer>
                <TableToolbar>
                  <TableToolbarContent className="table-toolbar-custom-content">
                    <div className="bx--col-lg-8 bx--col-md-10 table-toolbar-custon-content-info-start ">
                      <h6>{timelineTblTitle}</h6>
                    </div>
                    <div className="bx--col-lg-4 bx--col-md-2 table-toolbar-custon-content-info-end ">
                      {!editingDisabled ? (
                        <Button
                          onClick={() => handleNewElementModal()}
                          kind="primary"
                          renderIcon={Add16}
                          disabled={editingDisabled}
                          iconDescription=""
                        >
                          Add New Activity
                        </Button>
                      ) : (
                        ''
                      )}
                    </div>
                  </TableToolbarContent>
                </TableToolbar>
                <Table>
                  <TableHead>
                    <TableRow>
                      {timelineHeader.map((header) => (
                        <TableHeader {...getHeaderProps({ header })}>{header.header}</TableHeader>
                      ))}
                      <TableHeader className="align-center">Actions</TableHeader>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {!rows || rows.length < 1 ? (
                      <NoRecordsPlaceholder labelText="No Records" colSpan={timelineHeader.length + 1} />
                    ) : (
                      rows.map((row) => (
                        <TableRow key={`row_${row.id}`}>
                          {row.cells.map((cell) => (
                            <TableCell key={cell.id}>
                              {cell.info.header.includes('date')
                                ? moment(cell.value).format('DD/MM/YYYY')
                                : cell.info.header.includes('workSite')
                                ? cell.value?.name || 'N/A'
                                : cell.value}
                            </TableCell>
                          ))}
                          <TableCell key="action" className="tableActions align-center">
                            <div>
                              <Button
                                onClick={() => handleNewElementModal(row.id)}
                                size="small"
                                renderIcon={Edit16}
                                iconDescription="Edit"
                                kind="ghost"
                                disabled={editingDisabled}
                              />
                              <Button
                                onClick={() => handleDeleteElementModal(row.id)}
                                size="small"
                                renderIcon={Delete16}
                                iconDescription="Delete"
                                kind="ghost"
                                disabled={editingDisabled}
                              />
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          />
          {validationTimelines}
        </Tile>
    );

};

Timeline.propTypes = {
    timelineHeader : PropTypes.array.isRequired,
    dataRows : PropTypes.array,
    timelineTblTitle: PropTypes.string.isRequired,
    editingDisabled : PropTypes.bool,
    validationTimelines : PropTypes.func.isRequired,
    handleNewElementModal : PropTypes.func.isRequired,
    handleDeleteElementModal : PropTypes.func.isRequired
}

export default Timeline;